<pai-cards-carousel [items]="data().cards" />
